<template>
  <div>
    <v-row>
      <v-col cols="4">
        <v-autocomplete
            v-model="cuestionario_seleccionado"
            :label="$t('Cuestionarios')"
            :items="data_form.cuestionarios"
            outlined
            dense
            hide-details
        />
      </v-col>

      <v-col cols="4" class="pl-0 ml-0">
        <v-btn @click="nuevo_cuestionario" class="primary ml-2" :disabled="!cuestionario_seleccionado">
          {{ $t('Rellenar cuestionario') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <TablaCuestionariosRealizados
            :selected_filters="{'cliente': cliente.id}"
            ref="tabla_cuestionarios_realizados"
            @on_click_edit="edit_cuestionario"
            @on_click_delete="delete_cuestionario"
        />
      </v-col>
    </v-row>

    <FormCuestionarioRealizado
        ref="dialog_cuestionario"
        @on_save="get_cuestionarios_realizados"
    />
  </div>
</template>


<script>
export default {
  name: 'Cuestionarios',
  props: {
    cliente: {
      type: Object,
      required: true
    }
  },

  data(){
    return {
      cuestionario_seleccionado: null,
      data_form: {
        cuestionarios: []
      }

    }
  },

  methods:{

    /**
     * Recupera los cuestionarios de configuración para el desplegable
     * @returns {Promise<void>}
     */
    async get_cuestionarios(){
      const resp = await this.$store.dispatch('cliente/get_cuestionarios')
      this.data_form.cuestionarios = resp['results']
    },

    /**
     * Edita un cuestionario realizado
     * @param item
     * @returns {Promise<void>}
     */
    async edit_cuestionario(item){
      const cuestionario = await this.$store.dispatch('cliente/get_cuestionario_realizado', item.id)
      this.$refs.dialog_cuestionario.open_cuestionario(cuestionario)
    },

    /**
     * Elimina un cuestionario realizado
     * @param item
     * @returns {Promise<void>}
     */
    async delete_cuestionario (item) {
      try {
        await this.$store.dispatch('cliente/delete_cuestionario_realizado', item.id)

        this.$snotify.success(
            this.$t('Acción realizada con éxito'),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )

        this.get_cuestionarios_realizados()

      } catch (e) {
        this.$snotify.error(
            this.$t('Ha ocurrido un error'),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    /**
     * Crea un nuevo cuestionario realizado
     * @returns {Promise<void>}
     */
    async nuevo_cuestionario(){
      const cuestionario = await this.$store.dispatch('cliente/get_cuestionario', this.cuestionario_seleccionado)

      // Generamos el cuestionario con el formato correcto
      let cuestionario_to_save = {
        cuestionario: cuestionario,
        cliente: this.cliente.id,
        preguntas: []
      }

      cuestionario.preguntas.forEach((current_pregunta) => {
        cuestionario_to_save.preguntas.push({
          texto_respuesta: null,
          respuesta_radio: false,
          pregunta: {...current_pregunta}
        })
      })

      this.$refs.dialog_cuestionario.open_cuestionario(cuestionario_to_save)
    },

    /**
     * Recupera los cuestionarios realizados desde la api
     */
    get_cuestionarios_realizados(){
      this.$refs.tabla_cuestionarios_realizados.get_cuestionarios_realizados()
    }
  },

  mounted() {
    this.get_cuestionarios()
  },

  components: {
    TablaCuestionariosRealizados: () => import('@/views/Clientes/Components/TablaCuestionariosRealizados'),
    FormCuestionarioRealizado: () => import('@/views/Clientes/Components/FormCuestionarioRealizado')
  }
}
</script>
